export default [
    {
        path: "/voucher/canteen/sales",
        component: () => import("@/App/Canteen/Voucher/Sales/Components/List.vue"),
        name: "voucher.canteen.sales",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/sales/bulk",
        component: () => import("@/App/Canteen/Voucher/Sales/Components/BulkSale.vue"),
        name: "voucher.canteen.bulk.sales",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/sales/create",
        component: () => import("@/App/Canteen/Voucher/Sales/Components/Create.vue"),
        name: "voucher.canteen.sales.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/sales/emi",
        component: () => import("@/App/Canteen/Voucher/Sales/Components/CreateEmi.vue"),
        name: "voucher.canteen.sales.emi",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/sales/pos-sales",
        component: () => import("@/App/Canteen/Voucher/Sales/Components/PosSales.vue"),
        name: "voucher.canteen.pos.sales.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/pos-multi/create",
        component: () => import("@/App/Canteen/Voucher/Sales/Components/CounterPosMulti.vue"),
        name: "voucher.canteen.pos-multi.sales.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/sales-multi/create",
        component: () => import("@/App/Canteen/Voucher/Sales/Components/MultiSales.vue"),
        name: "voucher.canteen.multi.sales.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/sales/counter-pos",
        component: () => import("@/App/Canteen/Voucher/Sales/Components/CounterPos.vue"),
        name: "voucher.canteen.pos.counter.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/sales/pay-back",
        component: () => import("@/App/Canteen/Voucher/Sales/Components/PayBack.vue"),
        name: "voucher.canteen.pos.counter.payback",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/purchase-return/create",
        component: () => import("@/App/Canteen/Voucher/Sales/Components/PurchaseReturn.vue"),
        name: "voucher.canteen.purchase.return.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/sales/:id/edit",
        component: () => import("@/App/Canteen/Voucher/Sales/Components/Edit.vue"),
        name: "voucher.canteen.sales.edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/sales/:id/view",
        component: () => import("@/App/Canteen/Voucher/Sales/Components/View.vue"),
        name: "voucher.canteen.sales.view",
        meta: {
            requiresAuth: true,
        },
    },
];
